<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{getTitleText}}</div>
    <div slot="body">
      <form v-on:submit.prevent="submitForm">
        <label class="mt20">{{'Price'|translate}} <span class="required">(*)</span></label>
        <input
          v-model="item.price"
          required
          ref="price"
          :placeholder="'Price'|translate"
          class="form-control"
        />
        <label class="mt20">{{'Description'|translate}}</label>
        <textarea
          v-model="item.description"
          ref="description"
          :placeholder="'Description'|translate"
          class="form-control"
        ></textarea>
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">{{'Store'|translate}}</label>
            <select class="form-control" v-model="item.store_id" required>
              <option disabled value>{{'Please select one'|translate}}</option>
              <option
                v-for="(store) in stores"
                :key="store.id"
                v-bind:value="store.id"
              >{{ store.name }}</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">{{'Varriant'|translate}} <span class="required">(*)</span></label>
            <select class="form-control" v-model="item.varriant_id" required>
              <option disabled value>{{'Please select one'|translate}}</option>
              <option
                v-for="(varriant) in all_varriants"
                :key="varriant.id"
                v-bind:value="varriant.id"
              >{{ varriant.name }} ({{varriant.product_name}})</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">{{'Unit'|translate}} <span class="required">(*)</span></label>:
            <p>
              <span>{{unitName}}</span>
            </p>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">{{'Provider'|translate}} <span class="required">(*)</span></label>:

            <autocomplete
              ref="autocomplete"
              v-if="!selected_seller"
              :placeholder="'Search' | translate"
              :source="distributionGroupsEndpoint"
              input-class="form-control"
              results-property="data"
              :results-display="formattedDisplay"
              :request-headers="authHeaders"
              @selected="selectedMember"
            ></autocomplete>
            <p v-if="selected_seller">
              {{selected_seller.name}}
              <span>({{getTypeName(selected_seller.type)}})</span>
              <i
                v-if="!item.id"
                class="fas fa-times pointer pull-right"
                v-on:click="selected_seller = null"
              ></i>
            </p>
          </div>
        </div>

        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          {{getOKText}}
        </button>
      </form>
    </div>
  </mymodal>
</template>
<script>
import mymodal from '@/components/elements/Modal'
import Utils from '@/helpers/utils'
import Loading from '@/components/elements/Loading'
import Autocomplete from 'vuejs-auto-complete'
// import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: 'FormSaleAd',
  components: {
    mymodal,
    Loading,
    Autocomplete
  },
  props: ['pass_data', 'all_varriants', 'stores'],
  computed: {
    authHeaders () {
      return Utils.getHeader(this)
    },
    getTitleText () {
      if (this.item.id) {
        return this.$t('Update ad')
      } else {
        return this.$t('Add ad')
      }
    },
    unitName () {
      // console.log('all_varriants',this.all_varriants)
      if (!this.item.varriant_id) return this.$t('Please select varriant')
      let item = this.all_varriants.filter(item => {
        return item.id == this.item.varriant_id
      })
      return item.length > 0 ? item[0].unit_name : ''
    },
    getOKText () {
      if (this.item.id) {
        return this.$t('Update')
      } else {
        return this.$t('Add')
      }
    }
  },
  data () {
    return {
      working: false,
      item: {},
      selected_seller: null
    }
  },
  created () {
    // clone from original params
  },
  methods: {
    defaultValue () {
      return {
        price: '',
        description: '',
        varriant_id: '',
        store_id: ''
      }
    },
    open () {
      this.$refs.theModal.open()
      if (this.pass_data) {
        this.item = JSON.parse(JSON.stringify(this.pass_data))
        this.item.start_date = this.$moment(this.item.start_date).format(
          this.dateFormat
        )
      } else {
        this.item = this.defaultValue()
      }
    },
    submitForm () {
      if (!this.selected_seller) {
        return this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          this.$t('Please select provider')
        )
      }

      this.item.source_id = this.selected_seller.id
      this.item.source_type = this.selected_seller.type

      let data = JSON.parse(JSON.stringify(this.item))

      let request
      if (this.item.id) {
        request = Utils.request(this, true, 'salemarket').put(
          `/manageAds`,
          data
        )
      } else {
        request = Utils.request(this, true, 'salemarket').post(
          `/manageAds`,
          data
        )
      }

      request
        .then(response => {
          let data = response.data
          if (data.status === 'ok') {
            this.$refs.theModal.close()
            this.$emit('modalData', {})
          } else {
            Utils.showError(this, this.$t(data.data))
          }
        })
        .catch(error => {
          this.updating = false
          Utils.showErrorMessage(this, error.response)
        })
    },
    distributionGroupsEndpoint (input) {
      return Utils.getRequestUrl('group') + '/search_buyer?q=' + input
    },
    formattedDisplay (result) {
      let image_path = result.feature_image_path
        ? result.feature_image_path
        : this.src_image

      let type = result.type == 'farmer' ? 'Farmer' : 'Group'
      return (
        `<img src='${image_path}' width='50' height='50'/> ` +
        result.name +
        `( ${this.getTypeName(result.type)} )`
      )
    },
    selectedMember (member) {
      this.$refs.autocomplete.clear()
      this.selected_seller = member.selectedObject
    },
    getTypeName (type) {
      return Utils.getTypeName(this, type)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/FormSaleAd.vue